import { createSlice } from "@reduxjs/toolkit";
import { Children } from "react";
import { clearDeviceLogs } from "../Api Methods/Api";
import { act } from "react";
import { actions } from "react-table";

const filterCatagoeries = ["key", "tag", 'uuid'];
const InputsPins = [21, 20, 16, 12, 4, 3, 2, 1];
const OutPutPins = [5, 6, 13, 19, 25, 26, 27, 28];

const initialState = {

    isLoadingStats: false,
    deviceStats: {},

    filterCatagoery: "key",
    SearchData: [],
    filteredData: [],

    singleDeviceHeaderData: {},
    singleDevicePins: [],
    singleDeviceID: null,
    singleDeviceUUID: null,
    singleDeviceCompanyName: null,
    singleDeviceEvents: null,
    DeviceUsers: {},
    DeviceUUID: null,
    isSocketConnected: false,
    DeviceDetails: null,
    DeviceUUID: null,
    DeviceDetailsExtras: null,
    CamectIntegationType: null,
    SiteData: null,
    LockID: null,
    Username: null,
    UserEmail: null,

    LiveViewTableData: [],
    AllSitesTableData: {
        data: [],
        request: null
    },
    ActiveSitesTableData: [],
    InactiveSitesTableData: [],
    ControllersTableData: [],
    OfflineControllersTableData: [],
    TempSchedulesTableData: [],
    ScheduleSitesTableData: [],
    GroupsTableData: [],
    ThirdPartyCCTVTableData: [],
    PadlocksTableData: [],
    KeyboxesTableData: [],
    SensorsTableData: [],
    GatewaysTableData: [],

    //All sites filters
    active: -1,
    online: 0,
    offline: 0,
    deviceTag: null,
    cloudController: 0,
    davantis: 0,
    g2cc: 0,
    ESP: 0,
    RPi: 0,
    groupName: null,
    includeSubgroups: 0,
    noTag: 0,
    searchTerm: null,
    noUsers: 0,
    liveViewStatus: -1,
    scheduleOnly: -1,
    hasAjax: 0,
    hasHik: 0,
    hasAIBOX: 0,
    hasDahua: 0,
    hasPadlock: 0,
    hasKeybox: 0,
    hasGateway: 0,
    hasSigfox: 0,
    hasIndSigfox: 0,
    hasEfento: 0,
    hasTeltonika: 0,
    hasSchedules: 0,
    hasTempSchedules: 0,
    activePinCount: -1,
    ruleV2Owner: 0,
    ruleV2Parent: 0,
    ruleV2Affected: 0,
    connectionIssues: 0,
    hasCamerasLinked: -1,
    billable: -1,
    billingFrequency: -1,
    billedTo: -1,

    /*
        billable: number, 
    billingFrequency: number,
    billedTo: number,
    sDateOfSale: number, 
    sLastInvoice: number, 
    sDateMadeActive: number
    
    */ 

    sortAsc: 0,
    sUserCount: 0,
    sCreated: 0,
    sFirmware: 0,
    sName: 0,
    sCameraCount: 0,
    sDateOfSale: 0,
    sLastInvoice: 0,
    sDateMadeActive: 1,

    hasFilters: false,

    //group sites filters
    gsActive: -1,
    gsOnline: 0,
    gsOffline: 0,
    gsDeviceTag: null,
    gsCloudController: 0,
    gsDavantis: 0,
    gsG2cc: 0,
    gsESP: 0,
    gsRPi: 0,
    gsIncludeSubgroups: 0,
    gsNoTag: 0,
    gsSearchTerm: null,
    gsNoUsers: 0,
    gsLiveViewStatus: -1,
    gsScheduleOnly: -1,
    gsHasAjax: 0,
    gsHasHik: 0,
    gsHasAIBOX: 0,
    gsHasDahua: 0,
    gsHasPadlock: 0,
    gsHasKeybox: 0,
    gsHasGateway: 0,
    gsHasSigfox: 0,
    gsHasIndSigfox: 0,
    gsHasEfento: 0,
    gsHasTeltonika: 0,
    gsHasSchedules: 0,
    gsHasTempSchedules: 0,
    gsActivePinCount: -1,
    gsRuleV2Owner: 0,
    gsRuleV2Parent: 0,
    gsRuleV2Affected: 0,
    gsConnectionIssues: 0,
    gsHasCamerasLinked: -1,
    gsBillable: -1,
    gsBillingFrequency: -1,
    gsBilledTo: -1,

    gsSortAsc: 0,
    gsSUserCount: 0,
    gsSCreated: 0,
    gsSFirmware: 0,
    gsSName: 0,
    gsSCameraCount: 0,
    gsSDateOfSale: 0,
    gsSLastInvoice: 0,
    gsSDateMadeActive: 1,

    gsHasFilters: false,

    //temp schedule filters
    selectedGroupFilter: [],
    selectedFilter: "",
    sortBy: [],
    page: 1,
    wHm: false,
    woHm: false,
    excludeLocks: false,
    excludePulse: false,
    portalSiteNameFilter: "",
    includes: true,
    refresh: 0,
    sitesWithHolidayMode: "",
    daysFilter: [],
    fuzzySearch: -1,
    siteLocation: null,
    siteType: null,
    CCTVType: null
}


const serviceSlice = createSlice({
    name: 'service',
    initialState,
    reducers: {

        updateSocketConnectionStatus: (state, action) => {
            state.isSocketConnected = action.payload;
        },
        // Stats   --------------------------------
        updateStats: (state, action) => {
            state.deviceStats = action.payload.data
        },
        loadingStats: (state, action) => {
            // console.log("loadingStatsReducer")

            if (action.payload === true) {
                state.isLoadingStats = true;
            } else {
                state.isLoadingStats = false;
            }
        },
        // Search --------------------------------
        setfilterCategory: (state, action) => {
            state.filterCatagoery = filterCatagoeries[action.payload]
        },
        setSearchData: (state, action) => {
            state.SearchData = action.payload.data;
        },
        filterData: (state, action) => {
            const fc = state.filterCatagoery;
            state.filteredData = state.SearchData.filter((item) => item[fc].includes(action.payload));

        },
        setSiteData: (state, action) => {
            state.SiteData = action.payload
        },
        setDeviceUsers: (state, action) => {
            const DeviceUsers = action.payload.data;

            DeviceUsers.map((user) => {
                if (user.invitedBy == "") {
                    user.invitedBy = "Added device using Site ID";
                }
            })
            // console.log(DeviceUsers);
            const filteredData = DeviceUsers.map(item => {
                // Create a copy of the object without the 'email' property
                const { portalAccess, ...rest } = item;
                return rest; // Return the new object without 'email'
            });
            // console.log(filteredData);   



            const filteredData2 = filteredData.map(item => {
                const DeviceID = state.singleDeviceID;
                const uuid = state.singleDeviceUUID;
                return { ...item, DeviceID, uuid };
            });


            state.DeviceUsers = filteredData2;

        },
        // Single Device --------------------------------
        updatingSingleDeviceData: (state, action) => {
            const { id, name, mac, key, ip, host, uuid, online, created, lastLoggedIn, status, tag, networkType, firmware, type, numInput, numOutput, latestFirmware, camectIntegrationType, deviceName, subGroup, active } = action.payload;
            state.singleDeviceHeaderData = { id, name, mac, key, ip, host, uuid, online, created, lastLoggedIn, status, tag, networkType, firmware, type, numInput, numOutput, latestFirmware, camectIntegrationType, deviceName, subGroup, active };
            state.singleDeviceID = id;
            state.singleDeviceUUID = uuid;
            state.singleDeviceCompanyName = name;
        },
        setSingleDeviceEvents: (state, action) => {
            const Events = action.payload.data;
            const desiredMonth = 10;

            // Geting all values for specified month
            const filteredDates = Events.filter(event => {
                const date = new Date(event.eventDate);
                return date.getUTCMonth() + 1 === desiredMonth; // Months are zero-based, so add 1
            })

            const getDaySuffix = (day) => {
                if (day >= 11 && day <= 13) {
                    return 'th';
                }
                switch (day % 10) {
                    case 1:
                        return 'st';
                    case 2:
                        return 'nd';
                    case 3:
                        return 'rd';
                    default:
                        return 'th';
                }
            };

            const useDateFormat = (passedDate) => {
                const date = new Date(passedDate);  // Create a javascript data object
                const day = date.getUTCDate();  //extracts the day in UTC time, returns a int
                const month = date.toLocaleString('en-US', { month: 'long' });  // toLocaleString formats the month component within the date object to human readable format. en-US is used to set it to US English, the second argument, is set to long as we want the full month. returns a string.
                const year = date.getUTCFullYear(); //returns a 4 digit int reprsenting the year
                const suffix = getDaySuffix(day);
                return `${day}${suffix} ${month} ${year}`;
            }

            //Formating the eventDate field
            const EventsForMonth = filteredDates.map((event) => {
                const { eventDate, ...rest } = event;
                const formattedDate = useDateFormat(eventDate)
                return {
                    eventDate: formattedDate,
                    ...rest
                }
            })

            // Creating a array that that hold all the days in the month that had events and the number of the events
            const resultArray = EventsForMonth.reduce((accumulator, currentValue) => {
                const existingDateObject = accumulator.find(
                    (item) => item.date === currentValue.eventDate
                );

                if (existingDateObject) {
                    existingDateObject.events += 1;
                } else {
                    accumulator.push({
                        date: currentValue.eventDate,
                        events: 1,
                    });
                }

                return accumulator;
            }, []);

            const newArray = resultArray.map((item) => ({
                ...item,
                events: item.events > 30 ? 30 : item.events,
            }));
            state.singleDeviceEvents = newArray;

        },
        setDeviceUUID: (state, action) => {
            state.DeviceUUID = action.payload;
        },
        setLockID: (state, action) => {
            state.LockID = action.payload;
        },
        setDeviceDetails: (state, action) => {


            const [DeviceDetailsParsed, id, DeviceExtraDetailsParsed] = action.payload;

            state.DeviceDetails = DeviceDetailsParsed;
            state.DeviceID = id;
            state.DeviceDetailsExtras = DeviceExtraDetailsParsed;

        },
        setCamectIntegationType: (state, action) => {
            state.CamectIntegationType = action.payload;
        },
        setLiveViewEnabledTableData: (state, action) => {
            state.LiveViewTableData = action.payload
        },

        setAllSitesTableData: (state, action) => {
            state.AllSitesTableData = action.payload
        },
        setActiveSitesTableData: (state, action) => {
            state.ActiveSitesTableData = action.payload
        },
        setInactiveSitesTableData: (state, action) => {
            state.InactiveSitesTableData = action.payload
        },
        setControllerSitesTableData: (state, action) => {
            state.ControllersTableData = action.payload
        },
        setOfflineControllerSitesTableData: (state, action) => {
            state.OfflineControllersTableData = action.payload
        },
        setTempSchedulesSitesTableData: (state, action) => {
            state.TempSchedulesTableData = action.payload
        },
        setScheduleSitesTableData: (state, action) => {
            state.ScheduleSitesTableData = action.payload
        },
        setGroupsTableData: (state, action) => {
            state.GroupsTableData = action.payload
        },
        set3rdPartyCCTVTableData: (state, action) => {
            state.ThirdPartyCCTVTableData = action.payload
        },
        setPadlocksTableData: (state, action) => {
            state.PadlocksTableData = action.payload
        },
        setKeyboxesTableData: (state, action) => {
            state.KeyboxesTableData = action.payload
        },
        setSensorsSitesTableData: (state, action) => {
            state.SensorsTableData = action.payload
        },
        setGatewaysTableData: (state, action) => {
            state.GatewaysTableData = action.payload
        },
        setUsername: (state, action) => {
            state.Username = action.payload
        },
        setUserEmail: (state, action) => {
            state.UserEmail = action.payload
        },
        updateFilters: (state, action) => {
            Object.assign(state, action.payload)
        },
        resetFilters: (state) => {
            Object.assign(state, initialState);
        },
        setHasFilters: (state, action) => {
            state.hasFilters = action.payload
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload
        },

        updateGSFilters: (state, action) => {
            Object.assign(state, action.payload)
        },
        resetGSFilters: (state) => {
            Object.assign(state, initialState);
        },
        setGSHasFilters: (state, action) => {
            state.hasFilters = action.payload
        },
        setGSSearchTerm: (state, action) => {
            state.searchTerm = action.payload
        },
        
    }
})

export const serviceActions = serviceSlice.actions;

export default serviceSlice.reducer;


